var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.subName == 'Article')?_c('Article'):_vm._e(),(_vm.$route.params.subName == 'Sound')?_c('Sound'):_vm._e(),(_vm.$route.params.subName == 'Video')?_c('Video'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }